import { render, staticRenderFns } from "./ChatKebabOptions.vue?vue&type=template&id=192a8ade&scoped=true"
import script from "./ChatKebabOptions.vue?vue&type=script&lang=ts"
export * from "./ChatKebabOptions.vue?vue&type=script&lang=ts"
import style0 from "./ChatKebabOptions.vue?vue&type=style&index=0&id=192a8ade&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192a8ade",
  null
  
)

export default component.exports